import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { SystemProfile } from '../../types/entities';

import { initialState, SystemProfileState } from './state';

const systemProfileSlice = createSlice({
  name: 'system-profile',
  initialState,
  reducers: {
    reset: () => initialState,
    loading: (state: SystemProfileState, action: PayloadAction<boolean>) => {
      state.error = undefined;
      state.loading = action.payload;
      state.loaded = !action.payload;
    },
    pending: (state: SystemProfileState, action: PayloadAction<boolean>) => {
      state.error = undefined;
      state.pending = action.payload;
    },
    success: (state: SystemProfileState, action: PayloadAction<SystemProfile>) => {
      state.error = undefined;
      state.loading = false;
      state.loaded = true;
      state.profile = action.payload;
    },
    fail: (state: SystemProfileState, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.loading = false;
      state.loaded = true;
      state.profile = undefined;
    },
    update: (state: SystemProfileState, action: PayloadAction<SystemProfile>) => {
      state.pending = false;
      state.profile = action.payload;
    }
  }
});

const { actions, reducer } = systemProfileSlice;
export const { reset, loading, success, fail, update, pending } = actions;
export default reducer;
